import { FormControl, FormControlLabel, FormHelperText, Grid, IconButton, Input, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { forwardRef } from 'react'
import { useInput, NumberFormatCustom, TextMaskCustom, TextMaskCustomSSN, TextMaskCustomDate, TextMaskCustomPhone, TextMaskCustomTaxID, TextMaskCustomZipCode, TextMaskCustom0to99, TextMaskCustomPercent, TextMaskCustomMCDOT, TextMaskCustomYear, TextMaskCustomDateNoMax } from "../hooks/inputHook";
import { fieldValidationDriversLicense, fieldValidationLegalAge, fieldValidationOwnerMCDOTOptional, fieldValidationAmount, fieldValidationTaxID, fieldValidationWebsite, fieldValidation, fieldValidationPhone, fieldValidationEmail, fieldValidationSSN, fieldValidationLicenseNum, fieldValidationZipCode, fieldValidation0to99, fieldValidationFloat, fieldValidationMCDOT, fieldValidationDate } from "../validators/fieldValidation"
import StepButtons from '../components/StepButtons'
import { Info } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { statesArr } from "../helpers/constantVariables";
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';

function Hauling({ },ref) {
  const [{ applicantDetails, activeStep }, dispatch] = useStateValue();

  const {
    value: truck_to_haul_for,
    setValue: setTruckToHaulFor,
    bind: bindTruckToHaulFor
  } = useInput(applicantDetails?.truck_to_haul_for || "");
  const {
    value: new_lease,
    setValue: setNewLease,
    bind: bindNewLease
  } = useInput(applicantDetails?.new_lease || "");
  const {
    value: hauling_phone,
    setValue: setPhone,
    bind: bindPhone
  } = useInput(applicantDetails?.hauling_phone || "");
  const {
    value: contact_person,
    setValue: setContactPerson,
    bind: bindContactPerson
  } = useInput(applicantDetails?.contact_person || "");
  const {
    value: hauling_address,
    setValue: setAddress,
    bind: bindAddress
  } = useInput(applicantDetails?.hauling_address || "");
  const {
    value: hauling_city,
    setValue: setCity,
    bind: bindCity
  } = useInput(applicantDetails?.hauling_city || "");
  const {
    value: hauling_state,
    setValue: setState,
    bind: bindState
  } = useInput(applicantDetails?.hauling_state || "");
  const {
    value: hauling_zipcode,
    setValue: setZipcode,
    bind: bindZipcode
  } = useInput(applicantDetails?.hauling_zipcode || "");
  const {
    value: monthly_gross_income,
    setValue: setMonthlyGrossIncome,
    bind: bindMonthlyGrossIncome
  } = useInput(applicantDetails?.monthly_gross_income || "");
  const {
    value: years_with_company,
    setValue: setYearsWithCompany,
    bind: bindYearsWithCompany
  } = useInput(applicantDetails?.years_with_company || "");
  const {
    value: commodity_hauled,
    setValue: setCommodityHauled,
    bind: bindCommodityHauled
  } = useInput(applicantDetails?.commodity_hauled || "");
  const { value: mc, setValue: setMc, bind: bindMc, } = useInput(applicantDetails?.mc || '');

  const onUpdateBasicInfo = () => {
    let validation = validate();
    dispatch({
      type: actionTypes.SET_SUBMIT_APPLICANT_DETAILS,
      applicantDetails: {
        ...applicantDetails,
        truck_to_haul_for: truck_to_haul_for,
        new_lease: new_lease,
        contact_person: contact_person,
        hauling_phone: hauling_phone,
        hauling_address: hauling_address,
        hauling_city: hauling_city,
        hauling_state: hauling_state,
        hauling_zipcode: hauling_zipcode,
        monthly_gross_income: monthly_gross_income,
        commodity_hauled: commodity_hauled,
        years_with_company: years_with_company,
        mc: mc
      }
    });
    return validation;
  }

  const validate = () => {
    let validateSuccess = { error: false, msg: '' }
    let success = {}
    success = fieldValidation(truck_to_haul_for, 'Truck To Haul For');
    if (success.error) return success;
    success = fieldValidation(new_lease, 'New contract');
    if (success.error) return success;
    success = fieldValidation(contact_person, 'Contact Person');
    if (success.error) return success;
    success = fieldValidation(hauling_phone, 'Phone');
    if (success.error) return success;
    success = fieldValidation(hauling_city, 'City');
    if (success.error) return success;
    success = fieldValidation(hauling_state, 'State');
    if (success.error) return success;
    return validateSuccess;
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 280,
      fontSize: theme.typography.pxToRem(11),
      border: '1px solid #dadde9',
    },
  }));

  return (
    <>
      <Grid item container textAlign="left" columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
        <Grid textAlign="left" item xs={12}>
          <Typography color={"#616365"} borderBottom={"3px solid #0ea723"} variant="h5" gutterBottom component="div">
            Hauling Reference
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Truck To Haul For"
            label="Truck To Haul For"
            name="truck_to_haul_for"
            autoComplete='off'
            {...bindTruckToHaulFor}
            required={true}
            error={fieldValidation(truck_to_haul_for, "Truck To Haul For").error}
            helperText={fieldValidation(truck_to_haul_for, "Truck To Haul For").msg}
            margin="normal"
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Grid container item columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid item xs={12} md={4} lg={4} xl={4}>
              <Typography marginTop={2} color={new_lease ? "#616365" : "#c02424"} variant="subtitle1" component="div">
                New Contract
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      For Leased-on owner operators: Have you been leased on to this company before, or is this a new business relationship?
                    </React.Fragment>
                  }
                >
                  <IconButton>
                    <Info sx={{ fontSize: '16px' }} />
                  </IconButton>
                </HtmlTooltip>
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} lg={8} xl={8}>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="position"
                required={true}
                sx={"margin-top:10px"}
                error={new_lease ? false : true}
                {...bindNewLease}
              >
                <FormControlLabel required={true} value="true" control={<Radio />} label="Yes" />
                <FormControlLabel required={true} value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6} margin={'auto'} sx={{marginTop: "16px"}}>
          <FormControl variant="standard"
            fullWidth>
            <InputLabel style={mc ? { color: '#616365' } : { color: '#FFAB00' }}>
              MC#</InputLabel>
            <Input
              {...bindMc}
              name="mc"
              id="mc"
              autoComplete='off'
              inputComponent={TextMaskCustomMCDOT}
            />
            <FormHelperText style={{ color: '#FFAB00' }}>{fieldValidationOwnerMCDOTOptional(mc, "MC#").msg}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Contact Person"
            label="Contact Person"
            name="contact_person"
            autoComplete='off'
            {...bindContactPerson}
            required={true}
            error={fieldValidation(contact_person, "Physical Address").error}
            helperText={fieldValidation(contact_person, "Physical Address").msg}
            margin="normal"
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <FormControl required={true} error={fieldValidation(hauling_phone, "Phone").error} variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Business Phone</InputLabel>
            <Input {...bindPhone} name="hauling_phone" id="hauling_phone" inputComponent={TextMaskCustomPhone} autoComplete="off" />
            <FormHelperText>{fieldValidationPhone(hauling_phone, "Phone").msg}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Address"
            label="Address"
            name="hauling_address"
            id="hauling_address"
            autoComplete='off'
            {...bindAddress}
            margin="normal"
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="City"
            label="City"
            name="hauling_city"
            id="hauling_city"
            autoComplete='off'
            {...bindCity}
            required={true}
            error={fieldValidation(hauling_city, "City").error}
            helperText={fieldValidation(hauling_city, "City").msg}
            margin="normal"
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            name="hauling_state"
            id="hauling_state"
            placeholder="State"
            label="State"
            margin="normal"
            fullWidth
            variant="standard"
            select
            {...bindState} 
            required={true}
            error={fieldValidation(hauling_state, "State").error}
            helperText={fieldValidation(hauling_state, "State").msg}
          >
            {(statesArr || []).map((states) => (
              <MenuItem key={states.code} value={states.code}>
                {states.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <FormControl variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Zip Code</InputLabel>
            <Input
              {...bindZipcode}
              name="hauling_zipcode"
              id="hauling_zipcode"
              autoComplete='off'
              inputComponent={TextMaskCustomZipCode}
            />
            {/* <FormHelperText>{fieldValidationZipCode(zipcode, "Zip Code").msg}</FormHelperText> */}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <FormControl variant="standard" margin="normal" fullWidth>
            <InputLabel htmlFor="formatted-text-mask-input">Monthly Gross Income</InputLabel>
            <Input
              startAdornment={<InputAdornment position="start">$</InputAdornment>}
              type="number"
              value={monthly_gross_income}
              name="monthly_gross_income"
              id="monthly_gross_income"
              {...bindMonthlyGrossIncome}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Years with the company"
            label="Years with the company"
            name="years_with_company"
            autoComplete='off'
            {...bindYearsWithCompany}
            margin="normal"
            fullWidth
            variant="standard"
            type="number"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <TextField
            placeholder="Commodity Hauled"
            label="Commodity Hauled"
            name="commodity_hauled"
            autoComplete='off'
            {...bindCommodityHauled}
            margin="normal"
            fullWidth
            variant="standard"
          />
        </Grid>
      </Grid>
      <StepButtons updateInfo={onUpdateBasicInfo} ref={ref} />
    </>
  )
}

export default forwardRef(Hauling)